
/**
 * Module dependencies.
 */

import { color, globalStyles } from 'react-components/styles';
import { createGlobalStyle } from 'styled-components';
import { typography } from './typography/typography-styles';

/**
 * Export `GlobalStyle` component.
 */

export const GlobalStyle = createGlobalStyle`
  ${globalStyles}

  body {
    ${typography.styles.textNormal}

    color: ${color('secondary')};
    font-family: ${typography.fontFamilies.inter};
  }

  ol {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  svg {
    display: block;
  }

  sub, sup {
    font-size: 60%;
  }
`;
